import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { createPartners } from '../../api/partner.ts';
import type { CreatePartnerRequest } from '../../api/requests/partner-request.ts';

export default function useCreatePartner(): UseMutationResult<
  string,
  Error,
  CreatePartnerRequest
> {
  return useMutation({
    mutationFn: createPartners,
  });
}
